import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@themesberg/react-bootstrap';
import { FaEdit, FaPlus, FaCreditCard, FaEye } from 'react-icons/fa';

export default function ModalTriggerButton({
  onClick,
  button_text,
  button_variant = 'outline-primary',
  disabled = false,
  className = '',
}) {
  const version = useSelector((state) => state.uiVersion?.version || 'v2');

  if (version === 'v2') {
    const lower = (button_text || '').toLowerCase().trim();

    if (lower === 'editar' || lower === 'modificar') {
      return (
        <button
          type="button"
          disabled={disabled}
          className={`v2-action-btn v2-action-edit ${className}`}
          title={button_text}
          aria-label={button_text}
          onClick={onClick}
        >
          <FaEdit />
        </button>
      );
    }

    if (lower.startsWith('crear') || lower.startsWith('nuevo') || lower.startsWith('agregar')) {
      return (
        <button
          type="button"
          disabled={disabled}
          className={`v2-btn v2-btn-primary mb-3 ${className}`}
          onClick={onClick}
        >
          <FaPlus /> {button_text}
        </button>
      );
    }

    if (lower === 'gestionar' || lower.includes('pago')) {
      return (
        <button
          type="button"
          disabled={disabled}
          className={`v2-action-btn v2-action-edit ${className}`}
          title={button_text}
          aria-label={button_text}
          onClick={onClick}
        >
          <FaCreditCard />
        </button>
      );
    }

    if (lower === 'detalle' || lower === 'ver') {
      return (
        <button
          type="button"
          disabled={disabled}
          className={`v2-action-btn v2-action-edit ${className}`}
          title={button_text}
          aria-label={button_text}
          onClick={onClick}
        >
          <FaEye />
        </button>
      );
    }

    return (
      <button
        type="button"
        disabled={disabled}
        className={`v2-btn v2-btn-secondary ${className}`}
        onClick={onClick}
      >
        {button_text}
      </button>
    );
  }

  return (
    <Button variant={button_variant} disabled={disabled} onClick={onClick} className={className}>
      {button_text}
    </Button>
  );
}
